// extracted by mini-css-extract-plugin
module.exports = {"container":"_2KBpUAS02NRAXJ4kkcpsn4","restaurantsList":"_2TOMBgc2fyjuSJvv4s0qyI"};